import { AppLabels } from '@/types/App';
import { proxy } from 'valtio';

export type WrapperStore = {
  ui: {
    visible: boolean;
    labels: AppLabels;
  };
};

const state = proxy<WrapperStore>({
  ui: {
    visible: true,
    labels: {
      backToGame: 'BACK TO GAME',
    },
  },
});

const toggleVisibility = (visible?: boolean) => {
  if (visible !== undefined) state.ui.visible = visible;
  else state.ui.visible = !state.ui.visible;
};

const updateLabels = (labels?: Partial<AppLabels>) => {
  state.ui.labels = { ...state.ui.labels, ...labels };
};

export const wrapperStore = {
  state,
  actions: { toggleVisibility, updateLabels },
};
